import { v4 as uuidv4 } from 'uuid';
import * as Types from './types';
import * as Actions from './actions';

export const formReducer = (
    state: Types.FormState = { ...Types.formInitialState, guid: uuidv4() },
    action: Actions.FormActionReturns
): Types.FormState => {
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { type: actionType, payload } = action as any;
    switch (actionType) {
        case Types.UPDATE_NAME: {
            if (state.name !== payload.name) {
                return {
                    ...state,
                    name: payload.name,
                    isDirty: true,
                };
            }
            return state;
        }
        case Types.UPDATE_VALUE: {
            const values = {
                ...state.values,
                [payload.category]: { ...state.values[payload.category] },
            };
            // istanbul ignore if
            if (!values[payload.category]) {
                values[payload.category] = {};
            }
            values[payload.category][payload.valueName] = payload.value;
            return {
                ...state,
                values,
                isDirty: true,
            };
        }
        case Types.UPDATE_FORM_IS_DIRTY: {
            return {
                ...state,
                isDirty: payload.isDirty,
            };
        }
        case Types.REPLACE_FORM_STATE: {
            return {
                ...state,
                ...payload.state,
            };
        }
    }
    return state;
};

export const formCollectionReducer = (
    state: Types.FormCollectionState = { ...Types.formCollectionInitialState },
    action: Actions.FormActionReturns
): Types.FormCollectionState => {
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { type: actionType, payload } = action as any;

    switch (actionType) {
        case Types.RESET: {
            return {
                ...Types.formCollectionInitialState,
            };
        }
        case Types.UPDATE_FORM_IS_DIRTY:
        case Types.UPDATE_VALUE:
        case Types.UPDATE_NAME: {
            const forms = state.forms.map((itm) => {
                if (itm.guid !== payload.guid) {
                    return itm;
                }
                return formReducer(itm, action);
            });
            return {
                ...state,
                forms,
                isDirty: true,
            };
        }
        case Types.ADD_EMPTY_FORM: {
            const newform = {
                ...Types.formInitialState,
                type: payload.type,
                guid: payload.guid,
                name: payload.name,
                values: Types.createEmptyFormValuesData(payload.type),
            };
            const forms = [...state.forms, newform];
            return {
                ...state,
                forms,
                isDirty: true,
            };
        }
        case Types.DELETE_FORM: {
            const forms = [...state.forms.filter((bud) => bud.guid !== payload.guid)];
            return {
                ...state,
                forms,
                isDirty: true,
            };
        }
        case Types.CLONE_FORM: {
            const source = state.forms.find((bud) => bud.guid === payload.sourceGuid);
            if (source) {
                const clone = {
                    ...source,
                    guid: payload.destinationGuid,
                    name: payload.name,
                };
                const budgets = [...state.forms, clone];
                return {
                    ...state,
                    forms: budgets,
                    isDirty: true,
                };
            }
            return state;
        }
        case Types.UPDATE_COLLECTION_IS_DIRTY: {
            const apiId = state.apiId ? state.apiId : payload.apiId;
            return {
                ...state,
                isDirty: payload.isDirty,
                apiId,
            };
        }
        case Types.REPLACE_COLLECTION_STATE: {
            return {
                ...state,
                isDirty: false,
                apiId: payload.state.apiId,
                forms: [...payload.state.forms],
            };
        }
    }

    return state;
};
